// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"styles_sliderContainer__qd8Ff"};